<template>
    <div >
      <Tables ref="tableCustomersGrid"
                :columns="headTable"
                style="font-family:'Segoe UI'"
                :showSearch="false"
                :showPrint="false"
                :showDownload="false"
                :showFullscreen="false"
                v-on:Load="onLoad"
              >
                <tr v-for="customer in customersArray" :key="customer.id">
                    <TableColumn :IsText="true"   v-on:Edit="$emit('selectUser',customer)" :status="1" :value="customer.nome" />
                    <TableColumn :IsText="true"   v-on:Edit="$emit('selectUser',customer)" :status="1" :value="customer.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')" />
                    <TableColumn :IsText="true"   v-on:Edit="$emit('selectUser',customer)" :status="1" :value="customer.rg" />
                    <TableColumn :newState="true" v-on:Edit="$emit('selectUser',customer)" :newStatusNumber="customer.status == 0 ? 1 : 0" :descriptionNewStatus="['Ativo','Inativo', 'Ag. Aprovação'][customer.status]"  :status="1" :value="customer.status"/>
                    <TableColumn :IsText="true"   v-on:Edit="$emit('selectUser',customer)"  :status="1" :value="customer.dataAcaoFormatada" />
                    <TableColumn :IsActionsButtons="true" v-on:Change="$emit('inactivateUser', customer)" v-on:Delete="$emit('deleteCustomer', customer)" :status="customer.status === 1 ? 1 : 0" />
                </tr>
              </Tables>

    </div>
</template>
<script>
import CustomerTable from '@/views/private/realestate/users/components/CustomerTable/CustomerTable.js'
export default CustomerTable

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/users/components/CustomerTable/CustomerTable.vue